/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputCompleteWebAuthnVerificationRequest
 */
export interface InputCompleteWebAuthnVerificationRequest {
    /**
     * Challenge token
     * @type {string}
     * @memberof InputCompleteWebAuthnVerificationRequest
     */
    challenge: string;
    /**
     * JSON string from navigator.credentials.get()
     * @type {string}
     * @memberof InputCompleteWebAuthnVerificationRequest
     */
    credential: string;
}

/**
 * Check if a given object implements the InputCompleteWebAuthnVerificationRequest interface.
 */
export function instanceOfInputCompleteWebAuthnVerificationRequest(value: object): boolean {
    if (!('challenge' in value)) return false;
    if (!('credential' in value)) return false;
    return true;
}

export function InputCompleteWebAuthnVerificationRequestFromJSON(json: any): InputCompleteWebAuthnVerificationRequest {
    return InputCompleteWebAuthnVerificationRequestFromJSONTyped(json, false);
}

export function InputCompleteWebAuthnVerificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputCompleteWebAuthnVerificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': json['challenge'],
        'credential': json['credential'],
    };
}

export function InputCompleteWebAuthnVerificationRequestToJSON(value?: InputCompleteWebAuthnVerificationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'challenge': value['challenge'],
        'credential': value['credential'],
    };
}

